
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Message"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseMessage"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"referencedMessage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseMessage"},"directives":[]}]}}]}}],"loc":{"start":0,"end":234}};
    doc.loc.source = {"body":"#import \"./BaseMessage.graphql\"\n\n# Message data is in BaseMessage, this just adds referencedMessage for a nested message object\n\nfragment Message on Message {\n    ...BaseMessage\n\n    referencedMessage {\n        ...BaseMessage\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./BaseMessage.graphql").definitions));


      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/hooks/useMessages/Fragments/Message.graphql
// module id = 271
// module chunks = 21